import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "@/context/CartContext";
import CustomerHome from "@/pages/CustomerHome";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderSuccess from "@/pages/OrderSuccess";
import DepartmentHome from "@/pages/DepartmentHome";
import { SettingsProvider } from "@/context/SettingsContext";
import "@/App.css";

function App() {
    // Register PWA service worker (production only; dev mode uses HMR)
    React.useEffect(() => {
        if (process.env.NODE_ENV !== "production") {
            // In dev, proactively unregister any previously registered SW and clear caches
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.getRegistrations().then((regs) => {
                    regs.forEach((r) => r.unregister());
                }).catch(() => {});
                if (typeof caches !== "undefined") {
                    caches.keys().then((keys) => {
                        keys.forEach((k) => caches.delete(k));
                    }).catch(() => {});
                }
            }
            return;
        }
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker
                .register("/service-worker.js")
                .catch(() => {});
        }
    }, []);

    return (
        <div className="App">
            <SettingsProvider>
                <CartProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<DepartmentHome />} />
                            <Route path="/shop/:department" element={<CustomerHome />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/order/:id" element={<OrderSuccess />} />
                        </Routes>
                    </BrowserRouter>
                    <Toaster
                        position="top-center"
                        toastOptions={{
                            style: {
                                fontFamily: "Outfit, sans-serif",
                                borderRadius: "1rem",
                            },
                        }}
                    />
                </CartProvider>
            </SettingsProvider>
        </div>
    );
}

export default App;
